// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primary":"#56CCF2","textDefault":"#808080","default":"#868686","wrapper":"_25OXtWhFqY63hMksp9EZZ6","buttonView":"_22ci8q83k1yYAlwT7-kEz2","checked":"_2uXgE_YRbDNTmALARY5Kqv","input":"_2JubWWydNbRa5JBSZxPNTb","textLabel":"_3Q8cssLaz4iy-4LGTCSKdk","box":"_2LssVS47ZDpE0HvGAeq57O","label":"NxZG_NVFB8y5Ua2eGJo15","disabled":"_1K9s_To9Dnsycxj2he1OdB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CheckBox/CheckBox.mod.css
// module id = 1093
// module chunks = 0